module.exports = __webpack_public_path__ + "img/icon-num2.62b69869.png";